import React, { useCallback, useState } from 'react';
import { useParams } from 'umi';
import { useFilterSelector } from './useFilterSelector';
import { IFilterValueType } from '@/pages/benchmark/components/Filter/_type';
import CommonFilter from '@home/pages/studio/components/CommonFilter';
import RangePicker from '@home/components/RangePicker';
import { LANGUAGE_CN } from '@home/_config/config';
import moment from 'moment';
import './index.scss';
// import { getDateVal } from '@/pages/dashboard/utils/utils';
import { formatDateFromFilterValue, getMomentDate } from './utils';
import { formatDayTime } from '@home/pages/studio/utils';
import { ShortcutOption } from './_constant';
// url会传筛选器参数给详情页，详情页的筛选器数量是由后端接口决定，url参数只用来做值的设置
const KolFilter = (props: any) => {
  const { children, ...resetProps } = props;
  const [filterVal, setFilterVal] = useState<any>(null);
  const { loading, error, inputList, selectorList } = useFilterSelector({
    ...(resetProps || {})
  });
  const { gameCode } = useParams() || {} as any;
  // const isEN = getLocale() === LANGUAGE_EN;
  const config = {
    defaultTimeValue: [moment().startOf('day').subtract(7, 'days'), moment().startOf('day')],
    formatTime: formatDayTime,
    type: 'daily',
    isSingle: (start, end) => moment(end).diff(start, 'days') === 0,
    startOfWeek: 0,
    shortcutOption: ShortcutOption,
    defualtSelectedShortcut: ShortcutOption?.date?.[0]
  };

  const renderRangePicker = (props: any) => {
    const { value, componentDefault, type, key = 'date', typeList, startOfDate, latestDate, locale,
      onChange, dispatch, isReseted, setShortcutOption, seasonInfo, isEn, ...restProps } = props || {};
    const val = [getMomentDate(value?.[0]), getMomentDate(value?.[1])];
    return (
      <div className='search-item search-item-date'>
        {/* search-item search-item-date dbd-range-picker */}
        <RangePicker
          type={type}
          value={val}
          className="search-border"
          typeList={typeList}
          language={locale === LANGUAGE_CN ? 'cn' : 'en'}
          showSelectType={false}
          onChange={(value: any) => onChange(key, value)}
          // showShortcutTypeTitle={true}
          autoResetShortcutByValueChange={false}
          overlayClassName="dbh-studio-home-range-picker-overlay"
          {...(config?.shortcutOption && { setShortcutOption: () => config?.shortcutOption })}
          {...restProps}
        />
      </div>
    );
  };

  const inputListResult = [
    {
      type: 'date',
      key: 'date',
      typeList: ['date'],
      className: 'dbh-studio-kol-date-filter',
      shortcutOption: ShortcutOption?.date || [],
      default: [moment().startOf('day').subtract(6, 'days')?.format("YYYY-MM-DD"), moment().startOf('day')?.format("YYYY-MM-DD")],
      render: renderRangePicker,
    },
    ...(inputList || []),
  ];

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: IFilterValueType) => {
    setFilterVal(formatDateFromFilterValue(value));
  }, []);

  const onConfirm = useCallback((value: IFilterValueType) => {
    setFilterVal(formatDateFromFilterValue(value));
  }, []);

  const onReset = useCallback((value: IFilterValueType) => {
    setFilterVal(formatDateFromFilterValue(value));
  }, []);

  return <CommonFilter
    {...resetProps}
    loading={loading}
    error={error}
    selectorList={selectorList}
    value={filterVal}
    inputList={inputListResult}
    setFilterVal={setFilterVal}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    isHaveFilterSave={true}
    isHaveCollapse={true}
    filterSaveKey={`__db_studio_kol__`}
    gameCode={gameCode}
  >
    {children}
  </CommonFilter>;
};

export default KolFilter;
